import { Component, Input } from '@angular/core';
import { MartOrderDetailsComponent } from 'app/mart';

@Component({
    selector: 'mart-order-details-payment-tab',
    templateUrl: './mart-order-details-payment-tab.component.html',
    styleUrls: [
        './mart-order-details-payment-tab.component.scss',
        '../mart-order-details.component.scss'
    ]
})
export class MartOrderDetailsPaymentTabComponent {
    @Input()
    public parent!: MartOrderDetailsComponent;
}
